import type { PulseCard } from "@/types";

/** Editorial order: position ASC (pipeline posicion), relevance as tiebreaker. */
export function sortCards(cards: PulseCard[]): PulseCard[] {
  return [...cards].sort((a, b) => {
    if (a.position !== b.position) {
      return a.position - b.position;
    }
    return b.relevance_score - a.relevance_score;
  });
}
